/** @jsxImportSource theme-ui */
import React from 'react';
import { Link } from 'react-router-dom';

import { sxtheme } from 'utils/cssHelpers';

export const Stone90Link: React.FC<{ to: string }> = ({ to, children }) => (
  <Link
    to={to}
    sx={{
      color: sxtheme(t => t.colors.stone90),
      textDecoration: 'underline',
      '&:hover': {
        color: sxtheme(t => t.colors.stone90),
        textDecoration: 'underline',
      },
    }}
  >
    {children}
  </Link>
);
